import { Controller } from '@hotwired/stimulus';
import { getWindowWidth } from 'lib/helpers';

export default class SiteFooterController extends Controller {
  static targets = ['ddList'];

  connect() {
    this.setupDropdowns();
    window.addEventListener('resize', this.setupDropdowns);
  }

  setupDropdowns = () => {
    if (getWindowWidth() <= 720) {
      this.ddListTargets.forEach((list) => {
        if (!list.classList.contains('is-collapsed')) {
          list.classList.add('is-collapsed');
          const listIcon = list.querySelector('.ez-site-footer__nav__dd-icon');
          listIcon.classList.remove('ez-site-footer__nav__dd-icon--active');
        }
      });
    }
  }

  toggleMenu = (e) => {
    const ddMenu = e.target.closest('.ez-site-footer__nav__col');
    const ddIcon = ddMenu.querySelector('.ez-site-footer__nav__dd-icon');
    const languageDd = e.target.closest('.ez-site-footer__nav__link--more-languages div');

    this.ddListTargets.forEach((list) => {
      const shouldToggle = !list.classList.contains('is-collapsed')
                           && list !== ddMenu
                           && !languageDd;
      if (shouldToggle) {
        list.classList.add('is-collapsed');
        const listIcon = list.querySelector('.ez-site-footer__nav__dd-icon');
        listIcon.classList.remove('ez-site-footer__nav__dd-icon--active');
      }
    });

    if (!languageDd) {
      if (ddMenu.classList.contains('is-collapsed')) {
        ddMenu.classList.remove('is-collapsed');
        ddIcon.classList.add('ez-site-footer__nav__dd-icon--active');
      } else {
        ddMenu.classList.add('is-collapsed');
        ddIcon.classList.remove('ez-site-footer__nav__dd-icon--active');
      }
    }
  }
}
